function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genSearchListStyles = function genSearchListStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty({
    padding: '0px 24px'
  }, ".emptyWrap", {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px' // 这个值和ChoiceModal中的ContainerHeight一致
  }), ".listItem", _defineProperty(_defineProperty({
    display: 'flex !important',
    alignItems: 'center !important',
    gap: '8px !important',
    justifyContent: 'flex-start !important'
  }, ".checkbox", {
    padding: '4px'
  }), ".itemContent", _defineProperty(_defineProperty({}, ".title", {
    color: '#0D1121'
  }), ".subTitle", {
    fontSize: '12px',
    color: '#6E707A',
    cursor: 'pointer'
  }))), ".listItem:hover", {
    backgroundColor: '#E9EFFF'
  }))];
};